import { Song } from "@ts/models/song"
import { Get, API_URL, Post, V1_API_URL, Put } from "./network"

type SongType = "original" | "collab" | "cover" | "mashup"

export async function GetSong(id: id): Promise<Song> {
    const json = await Get(`/songs/${id}`)
    return Song.FromDict(json)
}
export async function GetSongs(ids: id[]): Promise<Song[]> {
    const json = await Post(`/songs/batch`, { ids })
    return json.map(Song.FromDict)
}

export async function GetAllSongs(ids?: id[], options: { title?: string, type?: SongType, offset?: number, limit?: number } = {}): Promise<Song[]> {
    const params = new URLSearchParams()

    if (ids) {
        for (const id of ids) {
            params.append("id", id)
        }
    }

    for (const [key, value] of Object.entries(options)) {
        if (value !== undefined) {
            params.set(key, String(value))
        }
    }

    const json = await Get(`/songs/?${params.toString()}`)
    return json.map(Song.FromDict)
}

export async function ExportSong(id: id) {
    const a = document.createElement("a")
    a.href = `${API_URL}/songs/${id}/gdrive`
    a.click()
    a.remove()
}

export async function ShareSongV1(id: id) {
    const response = await fetch(`${V1_API_URL}/songs/${id}/share`)
    if (!response.ok) {
        throw new Error("Failed to get share link")
    }

    const json = await response.json()
    if (!json.link) {
        throw new Error("Failed to get share link")
    }

    return json.link
}

export async function Search(query: string, limit = 10): Promise<Song[]> {
    if (!query) {
        return []
    }

    const params = new URLSearchParams({
        q: query.slice(0, 30),
        limit: String(limit)
    })

    const json = await Get(`/search?${params}`)
    if (!json) {
        return []
    }
    return json.map(Song.FromDict)
}

export function GetSongAudioUrl(id: id) {
    return `${API_URL}/songs/${id}/audio`
}

export function GetCoverUrl(path: string, size: "small" | "medium" | "large" = "medium") {
    return `${API_URL}/covers/${path}?size=${size}`
}
export async function UploadCover(path: string, file: File) {
    const formData = new FormData()
    formData.append("file", file)

    await fetch(`${API_URL}/covers/${path}`, {
        method: "POST",
        credentials: "include",
        body: formData
    })
}

export async function GetPlaylistsWithSong(songId: id): Promise<id[]> {
    const ids = await Get(`/songs/${songId}/playlists`)
    return ids
}

type PutArtist = {
    name: string
    originalName: string | undefined
}
export type PutData = {
    title: string,
    titleOriginal: string | undefined,

    artists: PutArtist[],
    singers: PutArtist[],
    type: "original" | "collab" | "cover" | "mashup",

    dateReleased: string,
    seconds: number,

    customArtwork: string | undefined
}

export async function PutSong(songId: id, data: PutData) {
    await Put(`/songs/${songId}`, data)
}